import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { hideUI } from "@/ui";
import store from "@/store";
const base = "/";

// 路由历史记录
const paths = {
  back: history.state?.back,
  forward: history.state?.forward,
};

// 缓存的路由url
const cachePaths = [{ path: "/home", component: "HomeView" }];

store.commit(
  "setInclude",
  cachePaths.map((item) => item.component),
);

const routes: Array<RouteRecordRaw> = [
  {
    path: "/:token",
    name: "token",
    component: () => import(/* webpackChunkName: "token" */ "../views/Token.vue"),
    children: [
      {
        path: "home",
        name: "home",
        component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue"),
        meta: {
          title: "灵隐访客码",
          // open: true,
        },
      },
      {
        path: "apply",
        name: "apply",
        component: () => import(/* webpackChunkName: "apply" */ "../views/apply/Apply.vue"),
        meta: {
          title: "访客申请",
          // open: true,
        },
      },
      {
        path: "apply/detail/:id",
        name: "applyDetail",
        component: () => import(/* webpackChunkName: "applyDetail" */ "../views/apply/Detail.vue"),
        meta: {
          title: "申请详情",
        },
      },
      {
        path: "login",
        name: "login",
        component: () => import(/* webpackChunkName: "login" */ "../views/Login.vue"),
        meta: {
          title: "登录",
          // open: true,
        },
      },
      {
        path: "update",
        name: "update",
        component: () => import(/* webpackChunkName: "update" */ "../views/Update.vue"),
        meta: {
          title: "个人信息",
          open: true,
        },
      },
      {
        path: "center",
        name: "center",
        component: () => import(/* webpackChunkName: "center" */ "../views/Center.vue"),
        meta: {
          title: "我的",
          open: true,
        },
      },
      {
        path: "guide",
        name: "guide",
        component: () => import(/* webpackChunkName: "guide" */ "../views/Guide.vue"),
        meta: {
          title: "上山引导",
          open: true,
        },
      },
      {
        path: "record",
        name: "record",
        component: () => import(/* webpackChunkName: "record" */ "../views/Record.vue"),
        meta: {
          title: "申请记录",
          // open: true,
        },
      },
    ],
  },
  {
    path: "/auth",
    name: "auth",
    component: () => import(/* webpackChunkName: "auth" */ "../views/Auth.vue"),
    meta: {
      title: "正在登陆...",
      open: true,
    },
  },
  {
    // 问卷调查
    path: "/survey/:name",
    name: "survey",
    component: () => import(/* webpackChunkName: "survey" */ `@/views/survey/Survey.vue`),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import(/* webpackChunkName: "404" */ "../views/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(base),
  routes,
});

router.beforeEach((to, from, next) => {
  hideUI();
  // 返回上一个路由采用返回的过渡动画
  const back = paths.back === to.fullPath;
  if (back) {
    from.meta.transition = "slide-left";
    to.meta.transition = "slide-right";
  } else {
    from.meta.transition = "slide-right";
    to.meta.transition = "slide-left";
  }
  // 在缓存的路由页面后退则去掉缓存
  const index = cachePaths.findIndex((p) => p.path === from.fullPath);
  if (back && index >= 0) {
    store.commit("setExclude", [cachePaths[index].component]);
  } else {
    store.commit("setExclude", []);
  }
  const meta = to.meta;
  if (typeof meta === "object" && meta.title) {
    document.title = meta.title + "";
  }
  next();
});
router.afterEach(() => {
  paths.back = history.state.back;
  paths.forward = history.state.forward;
});
export default router;
